import Vue from 'vue'
import App from './App.vue'
import router from './router';
import store from "./store";
Vue.config.productionTip = false

import VModal from 'vue-js-modal'


import Notifications from 'vue-notification'
Vue.use(Notifications)

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)


import Ws from '@adonisjs/websocket-client'
import WsPlugin from 'adonis-vue-websocket'
Vue.use(WsPlugin, { adonisWS: Ws })

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import panZoom from 'vue-panzoom'

Vue.use(panZoom);
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)


// import OneSignalVue from 'onesignal-vue'

// Vue.use(OneSignalVue);


//6a7013d5-7deb-4fda-9291-26198525cc15"

// window.OneSignal = window.OneSignal || [];
// window.OneSignal.push(function () {
//   OneSignal.init({
//     appId: "2df31aad-f3fe-4701-9dac-ab12b0433a5d",
//     allowLocalhostAsSecureOrigin:false
//   });
//   OneSignal.registerForPushNotifications();
// });



Vue.use(VModal, { componentName: 'modal' })


import VueI18n from "vue-i18n";
Vue.use(VueI18n);
// const messages = { en: en, fr: fr };
// const locale =
//   localStorage.getItem("currentLanguage") &&
//   localeOptions.filter(x => x.id === localStorage.getItem("currentLanguage"))
//     .length > 0
//     ? localStorage.getItem("currentLanguage")
//     : defaultLocale;
// const i18n = new VueI18n({
//   locale: locale,
//   // fallbackLocale: "en",
//   messages
// });







import socketio from 'socket.io-client'

import VueSocketIO from 'vue-socket.io'

import { MonthPicker } from 'vue-month-picker'
import { MonthPickerInput } from 'vue-month-picker'

import vuetify from './components/plugins/vuetify'
import '@mdi/font/css/materialdesignicons.css'


const options = { path: '/socket.io' };
Vue.use(new VueSocketIO({
  debug: true,
  // connection: socketio("https://125d-41-251-129-155.ngrok-free.app",options),
  // connection: socketio("https://space.monresto.menu:3030",options),
  connection: socketio("https://space.monresto.menu:3030", options),
  //  Optional options
}))

import moment from 'moment';
moment().format();


Vue.use(MonthPicker)
Vue.use(MonthPickerInput)

new Vue({
  // i18n,
  router,
  store,
  vuetify,
  // beforeMount() {
  //   this.$OneSignal.init({ appId: 'f2d6b0cf-6769-411a-b247-9c7a578684e8' });
  // },
  render: h => h(App),
}).$mount('#app')
